export default __webpack_public_path__ + "static/media/tunnel.ccd84b0d.svg";